import { render, staticRenderFns } from "./CampanhaVendaMargem.vue?vue&type=template&id=c088ad02&scoped=true"
import script from "./CampanhaVendaMargem.vue?vue&type=script&lang=js"
export * from "./CampanhaVendaMargem.vue?vue&type=script&lang=js"
import style0 from "./CampanhaVendaMargem.vue?vue&type=style&index=0&id=c088ad02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c088ad02",
  null
  
)

export default component.exports